import Ionicons from '@expo/vector-icons/Ionicons';
import { Pressable } from 'react-native';

interface HamburgerButtonProps {
  onPress: () => void;
}

export function HamburgerButton({ onPress }: HamburgerButtonProps) {
  return (
    <Pressable
      onPress={onPress}
      style={{ padding: 4 }}
      hitSlop={{ top: 10, bottom: 10, left: 10, right: 10 }}
      accessibilityRole="button"
      accessibilityLabel="Open menu"
    >
      <Ionicons name="menu" size={28} className="text-foreground" />
    </Pressable>
  );
}
